import * as Types from '../../../@graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type AuthorQueryVariables = Types.Exact<{
  uid: Types.Scalars['UUID'];
}>;


export type AuthorQuery = (
  { __typename?: 'Query' }
  & { author?: Types.Maybe<(
    { __typename?: 'Author' }
    & AuthorFieldsFragment
  )> }
);

export type PublicationEdgeAuthorFragment = (
  { __typename?: 'PublicationsEdge' }
  & { node?: Types.Maybe<(
    { __typename?: 'Publication' }
    & Pick<Types.Publication, 'uid' | 'title' | 'publishedAt' | 'status'>
  )> }
);

export type FigureVersionFieldsFragment = (
  { __typename?: 'FigureVersion' }
  & Pick<Types.FigureVersion, 'id'>
  & { figure: (
    { __typename?: 'Figure' }
    & Pick<Types.Figure, 'id' | 'uid' | 'src'>
    & { cropperPreview: (
      { __typename?: 'Image' }
      & Pick<Types.Image, 'url'>
    ) }
  ), crop: (
    { __typename?: 'Crop' }
    & Pick<Types.Crop, 'height' | 'left' | 'top' | 'width'>
  ), primaryProcessedImage?: Types.Maybe<(
    { __typename?: 'Image' }
    & Pick<Types.Image, 'url'>
  )> }
);

export type AuthorFieldsFragment = (
  { __typename?: 'Author' }
  & Pick<Types.Author, 'uid' | 'id' | 'firstName' | 'lastName' | 'description' | 'jobTitle' | 'status' | 'isActive' | 'surname' | 'mail'>
  & { editor?: Types.Maybe<(
    { __typename?: 'Editor' }
    & Pick<Types.Editor, 'id' | 'name'>
  )>, figureVersion?: Types.Maybe<(
    { __typename?: 'FigureVersion' }
    & FigureVersionFieldsFragment
  )>, publications?: Types.Maybe<(
    { __typename?: 'PublicationsConnection' }
    & { edges: Array<Types.Maybe<(
      { __typename?: 'PublicationsEdge' }
      & PublicationEdgeAuthorFragment
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>
    ) }
  )> }
);

export const FigureVersionFieldsFragmentDoc = gql`
    fragment FigureVersionFields on FigureVersion {
  id
  figure {
    id
    uid
    cropperPreview {
      url
    }
    src
  }
  crop {
    height
    left
    top
    width
  }
  primaryProcessedImage {
    url
  }
}
    `;
export const PublicationEdgeAuthorFragmentDoc = gql`
    fragment PublicationEdgeAuthor on PublicationsEdge {
  node {
    uid
    title
    publishedAt
    status
  }
}
    `;
export const AuthorFieldsFragmentDoc = gql`
    fragment AuthorFields on Author {
  uid
  id
  firstName
  lastName
  description
  jobTitle
  status
  isActive
  surname
  mail
  editor {
    id
    name
  }
  figureVersion {
    ...FigureVersionFields
  }
  publications(filter: {authorUid: $uid, status: PUBLISHED}) {
    edges {
      ...PublicationEdgeAuthor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${FigureVersionFieldsFragmentDoc}
${PublicationEdgeAuthorFragmentDoc}`;
export const AuthorDocument = gql`
    query author($uid: UUID!) {
  author(uid: $uid) {
    ...AuthorFields
  }
}
    ${AuthorFieldsFragmentDoc}`;

/**
 * __useAuthorQuery__
 *
 * To run a query within a React component, call `useAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useAuthorQuery(baseOptions: Apollo.QueryHookOptions<AuthorQuery, AuthorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorQuery, AuthorQueryVariables>(AuthorDocument, options);
      }
export function useAuthorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorQuery, AuthorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorQuery, AuthorQueryVariables>(AuthorDocument, options);
        }
export type AuthorQueryHookResult = ReturnType<typeof useAuthorQuery>;
export type AuthorLazyQueryHookResult = ReturnType<typeof useAuthorLazyQuery>;
export type AuthorQueryResult = Apollo.QueryResult<AuthorQuery, AuthorQueryVariables>;